import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom-v5-compat';
import { useSelector } from 'react-redux';
import { Skeleton } from '@mui/material';
import { useCheckAuthState, useDocumentFormData } from '@/hooks';
import { SendIcon } from '@/resources/icons';
import { ButtonLoading } from '@/components/common';
import { useSaveInvoice, useValidateInvoice } from '@/hooks/useSidebarActions';
import useStyles from '../../styles';

const handleOnClick = async ({
    invoice,
    saveInvoice,
    onLoginBlocker,
    validateInvoice,
    onNegativeInvoice,
    registeredUser,
    setLoading,
    total,
    navigate
}) => {
    const invoiceData = await validateInvoice(invoice);

    if (!invoiceData) return;

    if (total < 0) {
        onNegativeInvoice();
        return;
    }

    const completePreviewProcess = async () => {
        setLoading(true);

        let savedData;
        if (invoiceData?.documentState === 'draft') {
            savedData = await saveInvoice(invoiceData, 'preview');
            if (savedData === false) {
                setLoading(false);
                return;
            }
        } else {
            savedData = { ...invoiceData };
        }

        setLoading(false);

        if (savedData?.documentId !== null) {
            navigate(`/preview/${savedData?.documentId}`);
        }
    };

    // Check is a user is registered, if they are complete the process.
    // If not, see if we can get them to register.
    if (registeredUser) {
        completePreviewProcess();
    } else {
        onLoginBlocker(completePreviewProcess);
    }
};

const InvoicePreviewAndSend = ({
    onNegativeInvoice,
    onLoginBlocker,
    setLoading,
    loading,
    isDesktop
}) => {
    const classes = useStyles();
    const navigate = useNavigate();
    const { documentLoading, total } = useDocumentFormData();

    const { loadingUser, registeredUser } = useCheckAuthState();
    const saveInvoice = useSaveInvoice();
    const validateInvoice = useValidateInvoice();

    // Used for validation.
    const invoice = useSelector((state) => state?.makeInvoice);

    const loadingButton = loadingUser || documentLoading;

    return (
        <div className={classes.section}>
            {!loadingButton ? (
                <ButtonLoading
                    fullWidth
                    className={classes.primaryButton}
                    variant="contained"
                    color="primary"
                    endIcon={<SendIcon className={classes.buttonSendSvg} />}
                    onClick={() =>
                        handleOnClick({
                            invoice,
                            saveInvoice,
                            onLoginBlocker,
                            validateInvoice,
                            onNegativeInvoice,
                            registeredUser,
                            setLoading,
                            total,
                            navigate
                        })
                    }
                    size="large"
                    disableOnLoading
                    spinnerColor="primary"
                    loading={loading}
                    centerSpinner={!isDesktop}
                >
                    Preview & Send
                </ButtonLoading>
            ) : (
                <Skeleton variant="rectangular" className={classes.sizer} />
            )}
        </div>
    );
};

InvoicePreviewAndSend.propTypes = {
    onNegativeInvoice: PropTypes.func.isRequired,
    onLoginBlocker: PropTypes.func.isRequired,
    setLoading: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    isDesktop: PropTypes.bool.isRequired
};

InvoicePreviewAndSend.defaultProps = {
    loading: false
};

export default InvoicePreviewAndSend;
